import { type DirectoriesWithIconsBySearch } from './misc'

type SmartResults = Record<string, string[]> // uploadedId -> iconId[]

/**
 * Filter and reorder icons based on smart search results.
 * Icons are ordered by their position in the smart results.
 * Icons not in smart results are excluded.
 */
export function getSmartFilteredIcons(
	directoriesWithIcons: DirectoriesWithIconsBySearch,
	smartResults: SmartResults,
): DirectoriesWithIconsBySearch {
	// Build a set of all matched icon IDs with their order
	const allIconIds = Object.values(smartResults).flat()
	const iconOrder = new Map(allIconIds.map((id, index) => [id, index]))

	// Filter and reorder icons in each directory
	const filteredDirectories = directoriesWithIcons
		.map((directory) => {
			const matchedIcons = directory.icons
				.filter((icon) => iconOrder.has(icon.id))
				.sort((a, b) => {
					const orderA = iconOrder.get(a.id) ?? Infinity
					const orderB = iconOrder.get(b.id) ?? Infinity
					return orderA - orderB
				})

			return {
				...directory,
				icons: matchedIcons,
			}
		})
		.filter((directory) => directory.icons.length > 0)

	return filteredDirectories
}
